export default {
  // Options.jsx
  items_per_page: '/ side',
  label_items_per_page: 'Items / page',
  jump_to: 'Gå til side',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Forrige side',
  next_page: 'Neste side',
  prev_5: '5 forrige',
  next_5: '5 neste',
  prev_3: '3 forrige',
  next_3: '3 neste',
};
